import { IAccountRef } from 'shared/model';

export enum UserRole {
  Admin = 'admin',
  Editor = 'editor',
  Client = 'client',
}

export enum UserState {
  Created = 'created',
  Registered = 'registered',
}

export enum UserStatus {
  Active = 'active',
  Deactivated = 'deactivated',
}

export enum SubscriptionEmailFrequency {
  Immediate = 'immediate',
  Daily = 'daily',
  Weekly = 'weekly',
  None = 'none',
}

/** Account payload embedded in GET /api/v1/current_user (narrow subset). */
export interface ICurrentUserAccount {
  id: number;
  name: string;
  credits: number;
  unlimitedRequests: boolean;
  activePeriodEndsAt?: string;
  sourceOrganization?: { id: number; name: string | null } | null;
}

export interface ICurrentUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  role: UserRole;
  state: UserState;
  canUseTrackedSubjects: boolean;
  canExportProfiles: boolean;
  credits: number;
  denyRequests: boolean;
  subscriptionEmailFrequency: SubscriptionEmailFrequency;
  account: ICurrentUserAccount;
}

export interface IAdminUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  role: UserRole;
  location: string;
  status: UserStatus;
  createdAt: string;
  deactivatedAt?: string;
  credits: number;
  viewCredits: number;
  pdfCredits: number;
  denyRequests: boolean;
  denyViews: boolean;
  denyPdfs: boolean;
  denyExports: boolean;
  account: IAccountRef;
}
